import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'

import type ContractVersionRequest from 'modules/contracts/store/models/ContractVersionRequest'

type Props = {
  contractVersionRequest?: ContractVersionRequest | null
  canPromote: boolean
}

const useCanSeeApprovalRequest = ({ contractVersionRequest, canPromote }: Props): boolean => {
  const {
    access: { id: accessId },
  } = useCurrentSession()
  const status = contractVersionRequest?.attributes.status

  if (!contractVersionRequest || !canPromote || !status) return false
  const approversIds = contractVersionRequest?.attributes.approvers_ids || []
  const currentAccessIsApprover = approversIds.includes(accessId)

  return canPromote || currentAccessIsApprover
}

export default useCanSeeApprovalRequest
